// Recently scanned products, persisted in the browser's local storage only —
// never sent to the server (no PII, no accounts). Most-recent first, deduped by
// EAN, capped at MAX_ENTRIES.

const STORAGE_KEY = 'scanHistory'
const MAX_ENTRIES = 20

// localStorage can throw (private mode, quota, disabled). A failure here must
// never break the scanner, so every access is guarded.
function safeRead() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function safeWrite(entries) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
  } catch {
    /* ignore: nothing we can do if storage is unavailable */
  }
}

export function getHistory() {
  return safeRead()
}

// Record a successfully looked-up product. Keeps only the display fields we
// need; re-scanning an EAN moves it back to the top.
export function addToHistory(product, cheapestPrice) {
  if (!product?.ean) return getHistory()

  const entry = {
    ean: String(product.ean),
    name: product.name || '',
    brand: product.brand || '',
    quantity: product.quantity || '',
    unit: product.unit || '',
    scannedAt: new Date().toISOString(),
    cheapestPrice: cheapestPrice !== undefined ? cheapestPrice : null,
  }

  const rest = safeRead().filter((e) => e.ean !== entry.ean)
  const next = [entry, ...rest].slice(0, MAX_ENTRIES)
  safeWrite(next)
  return next
}

export function removeFromHistory(ean) {
  const rest = safeRead().filter((e) => e.ean !== String(ean))
  safeWrite(rest)
  return rest
}

export function clearHistory() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
